import { preCheckEvent } from "../studentPreChecksSlice";

export default function handleAddToLogStack(action, listenerApi, event){
    listenerApi.dispatch(preCheckEvent({
        type: `ready_${action.payload.item}`,
        item: action.payload.item,
        event,
      }))
}